import React from 'react';
import { withRouter } from 'react-router-dom';
import { FileSelection } from '../../containers/Files'
import FormContent from '../FormContent';
import NavigationTabs from '../nav/NavigationTabs'
import NavigationBlocker from './../navigationBlocker'
import Builder from './Builder';
import { VALIDATION_MESSAGES } from '../../static-content';
import { AlertJsMessage } from './../../helpers.js'

class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      expand: 1,
      isValidating: false,
      selectedPricingType: "0",
      sequence: {},
      dataLoaded: false,
      submitAction: 'create',
      edit: null,
      editProgram: null,
      showPricingInput: false,
      isDataChanged: false,
      formData: {
        name: '',
        description: '',
        level: '',
        price: '',
        privacy: '',
        categoryId: '',
        storeId: '',
        youtubeLink: '',
        isFeatured: false
      },
      sequenceData: {

      }
    };
  }

  componentDidMount() {
    const { user, editId } = this.props;
    this.props.fetch(user._id, editId).then(() => {

      const { editId, programs } = this.props;
      if (programs[editId]) {
        let curProgram = programs[editId];
        this.setState({
          selectedPricingType: curProgram.price ? "1" : "0",
          sequence: {},
          dataLoaded: true,
          edit: null,
          submitAction: 'edit',
          showPricingInput: curProgram.price ? true : false,
          formData: {
            name: curProgram.name,
            description: curProgram.description,
            level: curProgram.level,
            price: curProgram.price,
            privacy: curProgram.privacy,
            categoryId: curProgram.categoryId,
            storeId: curProgram.storeId,
            youtubeLink: curProgram.youtubeLink,
            isFeatured: curProgram.isFeatured
          },
          sequenceData: {

          }
        })
      } else {
        this.setState({
          ...this.state,
          dataLoaded: true
        })
      }

    });
  }

  componentWillUnmount() {
    this.setState({
      isDataChanged:  false
    });
  }


  handleChange = field => event => {
    if (field === 'price') {
      const priceProgram = event.target.value.replace(/[^0-9.]/g, "");
      this.setState({
        formData: {
          ...this.state.formData,
          price: priceProgram
        }
      })
    } else {
      if (field === 'isFeatured') {
        this.setState({
          formData: {
            ...this.state.formData,
            [field]: event.target.checked
          }
          })
      } else {
        this.setState({
          formData: {
            ...this.state.formData,
            [field]: event.target.value
          }
        })
      }
    }
    this.setState({
      isDataChanged: true
    })
  }

  handlePriceRadio = field => event => {
    if (event.target.value === '1') {
      this.setState({
        ...this.state,
        showPricingInput: true,
        selectedPricingType: "1"
      })
    } else {
      this.setState({
        ...this.state,
        formData: {
          ...this.state.formData,
          price: 0,
          storeId: ''
        },
        showPricingInput: false,
        selectedPricingType: "0"
      })
    }
  }

  matchYoutubeUrl(url) {
		const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
		if(url.match(p)){
			return url.match(p)[1];
		}
		return false;
	}

  validateForm() {
    const { weeks, deletedWeek } = this.builder.state;
    const { formData, showPricingInput } = this.state;
    //validate step 1 form Data
    const required = [
      'name',
      'level',
      'categoryId'
    ];
    showPricingInput && required.push('price');
    for (var i = 0; i < required.length; i++) {
      if (!formData[required[i]]) {
        AlertJsMessage(VALIDATION_MESSAGES['PROGRAM'][required[i]]);
        return;
      }
    }
    if(formData.youtubeLink && !this.matchYoutubeUrl(formData.youtubeLink)) {
			AlertJsMessage('Please enter valid youtube link.');
			return;
		}
    // validate empty weeks
    for (var week in weeks) {
      let weekData = weeks[week];
      if (!Object.values(weekData).some(w => w.workoutId && w.type)) {
        AlertJsMessage(`Please select atleast one workout in week ${week}.`)
        return;
      }

    }

    if(formData.youtubeLink) {
      this.submitValidatedForm(formData, weeks, undefined, deletedWeek);
    } else {
      const { type, selectedFile, previewVideoSrc, previewImageSrc } = this.fileSelect.state;
      if (type === 'library') {
        if (selectedFile) {
          this.submitValidatedForm(formData, weeks, selectedFile, deletedWeek);
        } else {
          AlertJsMessage("Please select a video or image for the cover.");
          return;
        }
      } else if (type === 'upload') {
        if (previewVideoSrc || previewImageSrc) {
          this.setState({
            ...this.state,
            isValidating: true
          }, () => {
            this.fileSelect.submitNewFile().then((file) => {
              this.submitValidatedForm(formData, weeks, file, deletedWeek);
            })
          })

        } else {
          AlertJsMessage("Please upload a video or image for the cover.")
        }
      }
    }


  }

  submitValidatedForm(formData, weeks, file, deletedWeek) {

    const { history, editId } = this.props;
    formData.weeks = Object.keys(weeks).length;
    if(file) {
      formData.fileId = file._id;
      if (file.fileType === 'mp4') {
        formData.videoUrl = file.url;
        formData.imgUrl = file.url;
      } else {
        formData.imgUrl = file.url;
      }
    }
    if (this.state.submitAction === 'create') {
      this.props.create(formData, weeks).then((res) => {
        this.setState({
          isDataChanged:  false
        }, () => {
          window.location.href = '/preview/programs/' + res._id + "?new=true";
        });
      });
    }
    if (this.state.submitAction === 'edit') {
      this.props.edit({ ...formData, id: editId }, weeks, deletedWeek).then((res) => {
        this.setState({
          isDataChanged:  false
        }, () => {
          window.location.href = '/preview/programs/' + res._id;
        });
      });
    }
  }
  handleExpand(step) {
    if (this.state.expand !== 0) {
      this.setState(state => ({ expand: state.expand === 1 ? 2 : 1 }));
    } else {
      this.setState({ expand: step });
    }
  }

  onCancel = () => {
    if (this.props.editId) {
      this.setState({ expand: 0 });
      return;
    } else {
      this.setState({
        expand: 0,
        formData: {
          name: '',
          description: '',
          level: '',
          price: '',
          privacy: '',
          categoryId: '',
          storeId: ''
        }
      });
      return;
    }
  }

  handlePrice = () => (event) => {
    const { value } = event.target;
    const { price } = Object.values(this.props.products).find(x => x.storeId === value);
    this.setState(state => ({
      formData: {
        ...state.formData,
        storeId: value,
        price
      }
    }))
  }

  render() {
    const { expand, showPricingInput, submitAction, formData, dataLoaded, selectedPricingType, isDataChanged } = this.state;
    const { programs, editId, user, cats, products, programInfo } = this.props;
    const curProgram = programInfo[editId];
    return (
      <div>
         <NavigationBlocker isDataChanged={isDataChanged}></NavigationBlocker>
        {
          this.props.hideNavigationTabs ? null : (
            <NavigationTabs
              title={editId ? 'Edit ' + formData.name : 'Build'}
              subtitle="Programs"
              description="Create programs by using workouts you have already built.  Programs must include at least 2 workouts."
              set="build"
              activeRoute="/build/program" />
          )
        }
        {dataLoaded &&
          <FormContent
            nameType="Program"
            editId={editId}
            formData={formData}
            expand={expand}
            products={products}
            expansionChange={(step) => this.handleExpand(step)}
            formChange={(field) => this.handleChange(field)}
            priceSelectionChange={() => this.handlePriceRadio()}
            selectedPricingType={selectedPricingType}
            showPricingInput={showPricingInput}
            submitAction={submitAction}
            workoutCats={cats}
            isValidating={this.state.isValidating}
            validateForm={() => this.validateForm()}
            onCancel={this.onCancel}
            priceRange={() => this.handlePrice()}
            FileSelection={(
              <FileSelection
                userData={user}
                fileType="mixed"
                category="PROGRAM_IMAGE"
                isSelectFromLibrary={true}
                isShowHelpIcon={true}
                selectedFileId={curProgram ? curProgram.fileId : 0}
                ref={(ref) => { this.fileSelect = ref ? ref.getWrappedInstance() : null }}
                showHelp
              />
            )}
            Builder={(
              <Builder
                days={curProgram ? curProgram['days'] : null}
                ref={(ref) => { this.builder = ref }}
                workouts={this.props.workouts}
                programWorkouts={this.props.programWorkouts}
                workoutCats={this.props.workoutCats}
                user={this.props.user}
                isValidating={this.state.isValidating}
                validateForm={() => this.validateForm()}
                actionType={submitAction}
                onCancel={this.onCancel}
                fetchMoreWorkouts = {this.props.fetchMoreWorkouts}
                isLoadMore={this.props.isLoadMore}
                resetWorkouts = {this.props.resetWorkouts}
              />
            )}
          />
        }

      </div>
    );
  }
}
export default withRouter(Form);



// WEBPACK FOOTER //
// ./src/components/programs/Form.js